import NavMenu from '../../components/navbar/NavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import StopSchedule from '../../components/stops/StopSchedule'

export default function StopSchedulePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <StopSchedule/>
        </>
    )
}
